import './index.css'
import { useRef } from 'react'
import { X, Image, FileText, Mic } from 'lucide-react'

export type AIMediaType = 'image' | 'pdf' | 'audio'

interface AIImportModalProps {
  /** Pode usar `open` (nome interno) ou `isOpen` (nome usado nos testes) */
  open?: boolean
  isOpen?: boolean
  onClose: () => void
  onFileSelected: (file: File, mediaType: AIMediaType) => void
}

export default function AIImportModal({ open, isOpen, onClose, onFileSelected }: AIImportModalProps) {
  const imageRef = useRef<HTMLInputElement>(null)
  const pdfRef   = useRef<HTMLInputElement>(null)
  const audioRef = useRef<HTMLInputElement>(null)

  const visible = open ?? isOpen ?? false
  if (!visible) return null

  function handleChange(mediaType: AIMediaType, input: HTMLInputElement | null) {
    const file = input?.files?.[0]
    if (!file) return
    onFileSelected(file, mediaType)
    onClose()
  }

  return (
    <div className="bc-sheet-overlay" onClick={onClose}>
      <div className="bc-ai-modal" onClick={e => e.stopPropagation()}>
        <div className="bc-ai-modal__header">
          <div>
            <h2 className="bc-ai-modal__title">Importar com IA</h2>
            <span className="bc-ai-modal__subtitle">Como deseja importar?</span>
          </div>
          <button className="bc-iconbtn" onClick={onClose} aria-label="Fechar">
            <X size={18} />
          </button>
        </div>

        <div className="bc-ai-modal__options">
          <button
            className="bc-ai-modal__option"
            onClick={() => imageRef.current?.click()}
          >
            <Image size={24} />
            <span>Foto do comprovante</span>
          </button>
          <button
            className="bc-ai-modal__option"
            onClick={() => pdfRef.current?.click()}
          >
            <FileText size={24} />
            <span>PDF / Boleto</span>
          </button>
          <button
            className="bc-ai-modal__option"
            onClick={() => audioRef.current?.click()}
          >
            <Mic size={24} />
            <span>Áudio descritivo</span>
          </button>
        </div>

        <input
          ref={imageRef}
          type="file"
          accept="image/*"
          data-testid="input-image"
          style={{ display: 'none' }}
          onChange={() => handleChange('image', imageRef.current)}
        />
        <input
          ref={pdfRef}
          type="file"
          accept="application/pdf"
          data-testid="input-pdf"
          style={{ display: 'none' }}
          onChange={() => handleChange('pdf', pdfRef.current)}
        />
        <input
          ref={audioRef}
          type="file"
          accept="audio/*"
          data-testid="input-audio"
          style={{ display: 'none' }}
          onChange={() => handleChange('audio', audioRef.current)}
        />

        <div className="bc-ai-modal__footer">
          <button onClick={onClose}>Cancelar</button>
        </div>
      </div>
    </div>
  )
}

